/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import {
  QuoteDisplayAmount,
  StoreConfigModel,
} from '@/quote-management/data/models';
import { DEFAULT_CONFIG } from '@/quote-management/lib/state';

export function transformStoreConfig(data: any): StoreConfigModel {
  if (!data) return DEFAULT_CONFIG;

  const transformQuoteDisplayAmountSetting = (
    quoteDisplayAmountSetting: number
  ) => {
    if (
      [
        QuoteDisplayAmount.TAX_EXCLUDED,
        QuoteDisplayAmount.TAX_INCLUDED,
        QuoteDisplayAmount.TAX_INCLUDED_AND_EXCLUDED,
      ].includes(quoteDisplayAmountSetting)
    ) {
      return quoteDisplayAmountSetting;
    }

    return QuoteDisplayAmount.TAX_EXCLUDED;
  };

  return {
    quoteSummaryDisplayTotal: data.cart_summary_display_quantity,
    quoteSummaryMaxItems: data.max_items_in_order_summary,
    quoteDisplaySettings: {
      zeroTax: data.shopping_cart_display_zero_tax,
      subtotal: transformQuoteDisplayAmountSetting(
        data.shopping_cart_display_subtotal
      ),
      price: transformQuoteDisplayAmountSetting(
        data.shopping_cart_display_price
      ),
      shipping: transformQuoteDisplayAmountSetting(
        data.shopping_cart_display_shipping
      ),
      fullSummary: data.shopping_cart_display_full_summary,
      grandTotal: data.shopping_cart_display_grand_total,
    },
    useConfigurableParentThumbnail:
      data.configurable_thumbnail_source === 'parent',
    quoteMinimumAmount: data.quote_minimum_amount ?? null,
    quoteMinimumAmountMessage: data.quote_minimum_amount_message ?? null,
  };
}
